import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const HEADERSOCIALITEMBLOCK_LEGACY_FIELD_ORDER = [
  "item",
  "link_url",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  headerSocialItemBlockDescriptor: _generatedHeaderSocialItemBlockDescriptor,
  headerSocialItemBlockBlocDefinition,
  headerSocialItemBlockDashboardLayout,
  headerSocialItemBlockConfig,
  headerSocialItemBlockResolveConfig,
  headerSocialItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Header - Social Link",
    componentType: "HeaderSocialItemBlockComponent",
    category: "navigation",
    description: "Header - Social Link.",
    keywords: [],
    allowedIn: [
      { bloc: "HeaderBlockComponent", slot: "left_blocks" },
      { bloc: "HeaderBlockComponent", slot: "right_blocks" },
      { bloc: "HeaderBlockComponent", slot: "navigation_links" },
    ],
    sharedFields: {},
  },

  () => ({
    item: propertyValue({
      type: "select",
      value: "facebook",
      options: {
        label: "pages.blocks.header-social-item.item.label",
        multiple: false,
        choices: [
          {
            value: "facebook",
            label: "pages.blocks.header-social-item.item.options.facebook",
          },
          {
            value: "instagram",
            label: "pages.blocks.header-social-item.item.options.instagram",
          },
          {
            value: "twitter",
            label: "pages.blocks.header-social-item.item.options.twitter",
          },
          {
            value: "linkedin",
            label: "pages.blocks.header-social-item.item.options.linkedin",
          },
          {
            value: "whatsapp",
            label: "pages.blocks.header-social-item.item.options.whatsapp",
          },
          {
            value: "google",
            label: "pages.blocks.header-social-item.item.options.google",
          },
        ],
      },
    }),
    link_url: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.header-social-item.link-url.label",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.header-social-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.header-social-item.fieldset.link.label",
            fields: ["item", "link_url"],
          },
        ],
      },
    ],
  }),
);

export function headerSocialItemBlockDescriptor(): IBlockDescriptor;
export function headerSocialItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function headerSocialItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedHeaderSocialItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedHeaderSocialItemBlockDescriptor,
    headerSocialItemBlockProperties,
    fieldOrder,
  );
}

export {
  headerSocialItemBlockBlocDefinition,
  headerSocialItemBlockDashboardLayout,
  headerSocialItemBlockProperties,
  headerSocialItemBlockConfig,
  headerSocialItemBlockResolveConfig,
};

export type HeaderSocialItemBlockConfig = typeof headerSocialItemBlockConfig;
